import {Box, Button, IconButton, TextField} from "@mui/material";
import '../../styles/chat.scss'
import Handle from "./handle";
import ClearIcon from '@mui/icons-material/Clear';
import AddIcon from '@mui/icons-material/Add';
import {ConversionType, ExtraProps, GenerateTagsTaskProcess, TaskStatusType} from "../../types/taskFlow.types";
import {useTaskFlow} from "../../context/TaskFlowContext";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import TaskTool from "../task_tool/confirm";
import Checkbox from "@mui/material/Checkbox";
import {useEffect, useState} from "react";
import { useTranslation } from 'react-i18next'

interface LabelsProps {
    taskResponse: GenerateTagsTaskProcess,
    taskId?: number,
    status: TaskStatusType,
    extra?: ExtraProps
}

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

export default function Labels (props: LabelsProps) {
    const {taskResponse, taskId, status, extra} = props;
    const {updateStatus, conversionValue, changeTaskProcess} = useTaskFlow();
    const [checkedLabels, setCheckedLabels] = useState<number[]>([])

    const { t } = useTranslation()

    const changeLabelsProcessRes = (index?: number, isCheck?: boolean) => {
        const data = isCheck ? [...checkedLabels, index as number] : checkedLabels.filter((v) => v !== index)
        setCheckedLabels(data)
        taskId && changeTaskProcess(taskId, {extra: { checkedLabels:data}})
    }

    const changeProcessRes = (value: string, index?: number, isDelete?: boolean) => {
        if (isDelete) {
            const data = taskResponse.data.filter((v , i) => {
                return index !== i
            })
            taskId && changeTaskProcess(taskId, {response: {...taskResponse, data}})
        }else if (index || index === 0) {
            const data = taskResponse.data.map((v , i) => {
                return index === i ? value : v
            })
            taskId && changeTaskProcess(taskId, {response: {...taskResponse, data}})
        }else {
            const data = [...taskResponse.data, '']
            taskId && changeTaskProcess(taskId, {response: {...taskResponse, data}})
        }
    }

    useEffect(() => {
        if (extra && extra?.checkedLabels) {
            setCheckedLabels(extra?.checkedLabels)
        }else if (taskResponse?.data) {
            const checked = Object.keys(taskResponse.data).map(v => parseInt(v));
            setCheckedLabels(checked)
            taskId && changeTaskProcess(taskId, {extra: { checkedLabels:checked}})
        }
    }, [taskResponse, taskId, extra]);

    const getBytesLength = (str: string) => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        if (!context) return '100px';

        context.font = '14px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial';
        const metrics = context.measureText(str);
        
        // 计算基础宽度
        const baseWidth = Math.ceil(metrics.width);
        // 设置最小宽度
        const minWidth = 50;
        // 额外空间（padding + border + 清除按钮）
        const extraSpace = 40;
        
        // 返回计算后的宽度，但不小于最小宽度
        return Math.max(baseWidth + extraSpace, minWidth) + 'px';
    }

    return <Box className="task_manage_box" >
        <Box className='flex' style={{alignItems: 'baseline'}}>
            <div style={{overflowWrap: "break-word"}}>{taskResponse.note}</div>
            <TaskTool status={status} taskId={taskId} text={t('confirm')}/>
        </Box>
        <Box className="task_manage_sub" style={{display: 'flex', flexWrap: 'wrap', paddingLeft: 0, paddingBottom: 0}}>
            {
                taskResponse.data?.map((val, index) => <div className="label_box" style={{width: getBytesLength(val)}} key={index}>
                    <Checkbox style={{position: 'absolute', right: 0, height: '26px'}}
                              size='small'
                              disabled={
                              conversionValue === ConversionType.HISTORY || status === TaskStatusType.COMPLETED}
                              checked={checkedLabels.includes(index)}
                              onChange={(e) =>{changeLabelsProcessRes(index, e.target.checked)}} {...label} defaultChecked />
                    <TextField
                        id="outlined-required"
                        size='small'
                        value={val}
                        onChange={(e)=>{changeProcessRes(e.target.value, index)}}
                        InputProps={{
                            readOnly: conversionValue === ConversionType.HISTORY || status === TaskStatusType.COMPLETED
                        }}
                    />
                </div>)
            }
            {
                conversionValue === ConversionType.CONVERSING &&  <IconButton aria-label="delete" size="medium" style={{height: '28px'}}>
                    <AddIcon onClick={() => {changeProcessRes('')}} fontSize="inherit"/>
                </IconButton>
            }
        </Box>
       <Box className='flex' style={{marginTop: 8}}><Handle/></Box>
    </Box>
}